import React from 'react';

export default function Work_Cafes() {
  return (
    <>
      <div className="container-fluid slider_top">
        <div className="row">
          <div className="col-lg-4 col-12">
            <img src="./assets/images/banner/workcafe1.jpg" alt="" className="bnr_img_30 padding_set" />
          </div>
          <div className="col-lg-4 col-12">
            <img src="./assets/images/banner/workcafe2.jpg" alt="" className="bnr_img_30 padding_set hide-on-mobile" />
          </div>
          <div className="col-lg-4 col-12">
            <img src="./assets/images/banner/workcafe3.jpg" alt="" className="bnr_img_30 padding_set hide-on-mobile" />
          </div>
        </div>
      </div>

      <section className="section-reservation-form padding-bottom-100">
        <div className="container">
        <div class="swin-sc swin-sc-title style-2">

<h3 class="title"><span>WORK CAFES</span></h3>
<p class="cafe-text text_justify">Work cafés have been aligned with new global standards embracing thematic design elements to create out of Workplace area concepts & to enhance overall experience.</p>
  </div>

          <div className="reservation-form  ">
            <div className="row">
              <div className="col-md-12">
                <div className="box-shadow ">
                  <div className="work_sustain">
                    <img src="./assets/images/icon/Beverage-machine.png" alt="" />
                    <p className="sustain_new">Tea/Coffee Vending</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">Wide variety of hot coffees and handpicked selection of teas</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row ">
              <div className="col-md-6">
                <div className="box-shadow box-equal">
                  <div className="work_sustain">
                    <img src="./assets/images/icon/filter-water.png" alt="" />
                    <p className="sustain_new">Hydration Station</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">Touch-based panel dispensing 3 states of water i.e. Hot, cold and Ambient</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="box-shadow box-equal">
                  <div className="work_sustain">
                    <img src="./assets/images/icon/microwave.png" alt="" />
                    <p className="sustain_new">Mini Markets</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">Healthy snacks and cold beverages available on selected floors</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 ">
                <div className="box-shadow box-equal">
                  <div className="work_sustain">
                    <img src="./assets/images/icon/fridge.png" alt="" />
                    <p className="sustain_new">Refrigerators</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">To store home cooked food</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="box-shadow box-equal p-2">
                  <div className="work_sustain">
                    <img src="https://image.shutterstock.com/image-vector/food-beverages-icon-600w-1043660497.jpg" style={{ width: '33px' }} alt="" />
                    <p className="sustain_new">Mug Concept</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">Leading to elimination of paper cups and fortifying our sustainable practices</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="swin-sc swin-sc-contact-form light mtl">&nbsp;</div>
          </div>
        </div>
      </section>
    </>
  );
}
